import React from 'react';
import Icon from '../../../components/AppIcon';

const MarketIndicesWidget = () => {
  const indices = [
    {
      name: 'S&P 500',
      symbol: 'SPX',
      value: '4,567.89',
      change: '+23.45',
      changePercent: '+0.52',
      isPositive: true
    },
    {
      name: 'Dow Jones',
      symbol: 'DJI',
      value: '34,123.56',
      change: '-45.67',
      changePercent: '-0.13',
      isPositive: false
    },
    {
      name: 'NASDAQ',
      symbol: 'IXIC',
      value: '14,789.23',
      change: '+67.89',
      changePercent: '+0.46',
      isPositive: true
    },
    {
      name: 'Russell 2000',
      symbol: 'RUT',
      value: '2,045.67',
      change: '+12.34',
      changePercent: '+0.61',
      isPositive: true
    }
  ];

  return (
    <div className="card-elevated p-6">
      <div className="flex items-center space-x-3 mb-6">
        <div className="p-2 bg-secondary/10 rounded-lg">
          <Icon name="BarChart3" size={20} className="text-secondary" />
        </div>
        <div>
          <h3 className="text-lg font-semibold text-foreground">Market Indices</h3>
          <p className="text-sm text-muted-foreground">Live market overview</p>
        </div>
      </div>

      <div className="space-y-4">
        {indices.map((index) => {
          const trendColor = index.isPositive ? 'text-success' : 'text-destructive';
          
          return (
            <div key={index.symbol} className="flex items-center justify-between p-3 rounded-lg hover:bg-muted/30 transition-colors">
              <div className="flex items-center space-x-3">
                <div className="flex items-center space-x-1">
                  <Icon 
                    name={index.isPositive ? "TrendingUp" : "TrendingDown"} 
                    size={14} 
                    className={trendColor} 
                  />
                </div>
                <div>
                  <h4 className="text-sm font-semibold text-foreground">{index.name}</h4>
                  <p className="text-xs text-muted-foreground">{index.symbol}</p>
                </div>
              </div>
              
              <div className="text-right">
                <p className="text-sm font-mono font-semibold text-foreground">{index.value}</p>
                <div className="flex items-center space-x-1">
                  <span className={`text-xs font-medium ${trendColor}`}>
                    {index.change}
                  </span>
                  <span className={`text-xs ${trendColor}`}>
                    ({index.changePercent}%)
                  </span>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <div className="mt-6 p-4 bg-muted/30 rounded-lg">
        <div className="flex items-center justify-between mb-2">
          <span className="text-sm font-medium text-foreground">Market Status</span>
          <div className="flex items-center space-x-2">
            <div className="w-2 h-2 bg-success rounded-full animate-pulse"></div>
            <span className="text-sm text-success font-medium">Open</span>
          </div>
        </div>
        <p className="text-xs text-muted-foreground">
          Market closes in 4h 23m • Last updated: {new Date().toLocaleTimeString()}
        </p>
      </div>
    </div>
  );
};

export default MarketIndicesWidget;